import {
  NftActivities,
  ActivityConfigType,
} from "@/app/(components)/Application/Nft/NftActivityDescription/types";

export const activityConfigNft: ActivityConfigType = {
  [NftActivities.MINT]: {
    text: "Minted",
  },
  [NftActivities.BURN]: {
    text: "Burned",
  },
  [NftActivities.TRANSFER]: {
    text: "Transfer to ${0}",
    args: ["to"],
  },
  [NftActivities.AUCTION_CREATE]: {
    text: "Listed for ${0} ${1}",
    args: ["price", "paymentLabel"],
  },
  [NftActivities.AUCTION_DUTCH_CREATE]: {
    text: "Started dutch auction with price ${0} ${1}",
    args: ["price", "paymentLabel"],
  },
  [NftActivities.AUCTION_SUCCESS]: {
    text: "Purchased from ${0} for ${1} ${2}",
    args: ["from", "price", "paymentLabel"],
  },
  [NftActivities.AUCTION_CANCEL]: {
    text: "Removed from sale",
  },
  [NftActivities.AUCTION_RESERVE]: {
    text: "Bid placed for ${0} ${1}",
    args: ["price", "paymentLabel"],
  },
  [NftActivities.OFFER_CREATE]: {
    text: "Offer made for ${0} ${1}",
    args: ["price", "paymentLabel"],
  },
  [NftActivities.OFFER_ACCEPT]: {
    text: "Offer accepted for ${0} ${1}",
    args: ["price", "paymentLabel"],
  },
  [NftActivities.OFFER_CANCEL]: {
    text: "Offer canceled",
  },
  [NftActivities.COLLECTION_OFFER_CREATE]: {
    text: "Collection offer made for ${0} ${1}",
    args: ["price", "paymentLabel"],
  },
  [NftActivities.COLLECTION_OFFER_CANCEL]: {
    text: "Collection offer removed",
  },
  [NftActivities.PRIVATE_AUCTION_SUCCESS]: {
    text: "Private purchased from ${0} for ${1}",
    args: ["from", "price"],
  },
};
